import { IconComponent } from './types';

const SectionsIcon: IconComponent = (props) => (
  <svg
    width={12}
    height={13}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={0.5}
      d="M.917 1.391h10.167v10.167H.917z"
    />
    <path
      fill="currentColor"
      d="M0 .475h2v2H0zM0 10.475h2v2H0zM10 10.475h2v2h-2zM10 .475h2v2h-2z"
    />
  </svg>
);

export default SectionsIcon;
